import useTranslation from '@space-core/hooks/useTranslation'
import { UserInfoRole } from '@space-shell/common/services/user'
import { useMembershipStore, useUserInfoStore } from '@space-shell/core/store'

import { AGENT_CATEGORY_ID, COMMUNITY_PRODUCT_CATEGORY_ID, EBOOK_CATEGORY_ID } from './constants'
import type { UseGetProductURLProps } from './types'

const useGetProductURL = ({ product, internalSalesPageUrl }: UseGetProductURLProps) => {
  const { membershipSlug } = useMembershipStore()
  const { role: userRole } = useUserInfoStore()
  const isOwner = userRole === UserInfoRole.OWNER

  const {
    i18n: { language }
  } = useTranslation()

  const { purchased, categoryId, productHotLink, accessLink, itemId, joined, communityId } = product
  const productHomeURL = `/${language.toLocaleLowerCase()}/club/${membershipSlug}/products/${itemId}`

  if (!purchased && !joined && (internalSalesPageUrl || productHotLink)) {
    const url = internalSalesPageUrl || productHotLink

    return url as string
  }

  if (categoryId === COMMUNITY_PRODUCT_CATEGORY_ID && communityId) {
    const communityProductURL = `/${language.toLocaleLowerCase()}/club/${membershipSlug}/community/${communityId}`

    return communityProductURL
  }

  if (categoryId === AGENT_CATEGORY_ID) {
    return `${productHomeURL}/agent`
  }

  if (categoryId === EBOOK_CATEGORY_ID) {
    const baseEbookPath = `${productHomeURL}/ebook`

    return isOwner ? `${baseEbookPath}/preview` : baseEbookPath
  }

  return accessLink || productHomeURL
}

export default useGetProductURL
